import { render, staticRenderFns } from "./AbkEventsList.vue?vue&type=template&id=71f59413&scoped=true&"
import script from "./AbkEventsList.vue?vue&type=script&lang=js&"
export * from "./AbkEventsList.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventsList.vue?vue&type=style&index=0&id=71f59413&scoped=true&lang=scss&"
import style1 from "./AbkEventsList.vue?vue&type=style&index=1&id=71f59413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f59413",
  null
  
)

export default component.exports